<template>
  <div class="project-invoice-section">
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div key="1" v-if="loader" class="white-row loader-route">
        <div class="lds-sub-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-else class="white-row">
        <div class="create-invoice-wrapper">
          <section class="top-heading-section-invoice">
            <div class="invoices-tab">
              <div class="row">
                <div class="col-sm-12">
                  <h4 class="sub-heading">Edit Old Payments</h4>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div class="form-area">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12">
                    <form
                      class="project-invoice-form"
                      v-on:submit.prevent="onSubmit($event)"
                    >
                      <div class="row">
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id"
                                >Order ID: <span>*</span></label
                              >
                              <input
                                v-model="formData.order_id"
                                type="text"
                                class="form-control"
                                placeholder="Order ID"
                                :class="{
                                  'input-border-errors':
                                    $v.formData.order_id.$dirty &&
                                    !$v.formData.order_id.required
                                }"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Order Date: </label>
                              <datepicker
                                :minimumView="'day'"
                                :maximumView="'month'"
                                :initialView="'month'"
                                v-model="formData.order_date"
                              >
                                <span
                                  slot="afterDateInput"
                                  class="animated-placeholder"
                                >
                                  <i class="far fa-calendar-alt"></i>
                                </span>
                              </datepicker>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Project Name: </label>
                              <input
                                v-model="formData.project_name"
                                type="text"
                                class="form-control"
                                placeholder="Project Name"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Client Name: </label>
                              <input
                                v-model="formData.client_name"
                                type="text"
                                class="form-control"
                                placeholder="Client Name"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Email: </label>
                              <input
                                v-model="formData.email"
                                type="email"
                                class="form-control"
                                placeholder="Client Email"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Amount: </label>
                              <input
                                v-model="formData.amount"
                                type="text"
                                class="form-control"
                                placeholder="Amount"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-3">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">currnecy: </label>
                              <input
                                v-model="formData.currency"
                                type="text"
                                class="form-control"
                                placeholder="Currency"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-9">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Product: </label>
                              <input
                                v-model="formData.product"
                                type="text"
                                class="form-control"
                                placeholder="Product"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Sale Member: </label>
                              <input
                                v-model="formData.sale_member"
                                type="text"
                                class="form-control"
                                placeholder="Sale Member"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Account Manager: </label>
                              <input
                                v-model="formData.account_manager"
                                type="text"
                                class="form-control"
                                placeholder="Account Manager"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Phone: </label>
                              <input
                                v-model="formData.phone"
                                type="tel"
                                class="form-control"
                                placeholder="Phone"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Comments: </label>
                              <input
                                v-model="formData.comment"
                                type="text"
                                class="form-control"
                                placeholder="Comment"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Order Link: </label>
                              <input
                                v-model="formData.order_link"
                                type="text"
                                class="form-control"
                                placeholder="Order Link"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="row">
                            <div class="form-group">
                              <label for="order_id">Teamwork Link: </label>
                              <input
                                v-model="formData.teamwork_link"
                                type="text"
                                class="form-control"
                                placeholder="Teamwork Link"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-12">
                          <div class="row">
                            <div class="form-actions">
                              <button
                                :disabled="disableSubmitBtn"
                                type="submit"
                                id="save-form"
                                class="default-global-btn"
                              >
                                Update
                              </button>
                              <div
                                v-if="disableSubmitBtn"
                                class="form_submit_loader"
                              >
                                <div class="lds-ellipsis">
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import Datepicker from "vuejs-datepicker";
// import Select2 from "v-select2-component";

import { validationMixin } from "vuelidate";
const {
  required,
  minLength,
  email,
  numeric,
  url
} = require("vuelidate/lib/validators");

export default {
  mixins: [validationMixin],
  name: "invoices.create",
  components: {
    // Select2,
    Datepicker
  },
  validations: {
    formData: {
      order_id: {
        required
      }
    }
  },
  data() {
    return {
      loader: true,
      disabled: true,
      formData: {
        id: null,
        order_id: null,
        order_date: null,
        project_name: null,
        client_name: null,
        email: null,
        amount: null,
        currnecy: null,
        product: null,
        sale_member: null,
        account_manager: null,
        phone: null,
        comment: null,
        order_link: null,
        teamwork_link: null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      },
      disableSubmitBtn: false
    };
  },
  mounted() {
    this.EditOldpayments();
    this.getProjectLists();
    this.loader = false;
  },
  computed: {},
  methods: {
    async getProjectLists() {
      const $this = this;
      const currnecy = $this.$store.dispatch("getHttp", {
        url: "filters/get-project-lists"
      });
      await currnecy.then(function(response) {
        if (typeof response !== "undefined") {
          $this.project_options = response.data.data;
        }
      });
    },

    async EditOldpayments() {
      const $this = this;
      const currnecy = $this.$store.dispatch("getHttp", {
        url:
          "old-payments/edit/" +
          $this.$route.params.payment_id +
          "?timezone=" +
          $this.formData.timezone
      });
      await currnecy.then(function(response) {
        if (typeof response !== "undefined") {
          $this.payment_data = response.data.data;
          console.log($this.payment_data);
          $this.formData.id = $this.payment_data.id;
          $this.formData.order_id = $this.payment_data.order_id;
          $this.formData.order_date = $this.payment_data.order_date;
          $this.formData.project_name = $this.payment_data.project_name;
          $this.formData.client_name = $this.payment_data.client_name;
          $this.formData.email = $this.payment_data.email;
          $this.formData.amount = $this.payment_data.amount;
          $this.formData.currency = $this.payment_data.currency;
          $this.formData.product = $this.payment_data.product;
          $this.formData.sale_member = $this.payment_data.sales;
          $this.formData.account_manager = $this.payment_data.am;
          $this.formData.phone = $this.payment_data.phone;
          $this.formData.comment = $this.payment_data.comments;
          $this.formData.order_link = $this.payment_data.order_link;
          $this.formData.teamwork_link = $this.payment_data.teamwork_link;
        }
      });
    },
    async onSubmit(event) {
      const $this = this;
      $this.disableSubmitBtn = true;
      $this.$v.$touch();

      if ($this.$v.$invalid) {
        $this.$store.dispatch("showtostrMessageNotifications", {
          message: "Please fill all the fields to proceed form!",
          type: "error"
        });
        $this.disableSubmitBtn = false;
        return;
      }

      // alert("hello");

      const data = $this.$store.dispatch("postHttp", {
        url: "old-payments/update",
        formDetails: this.formData,
        formEvent: event.target
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.$store.dispatch("displayMessageErrors", {
            response: response,
            formEvent: event.target
          });
          $this.$router.push({ path: "/old-payments" });
          $this.disableSubmitBtn = false;
        }
      });
      $this.disableSubmitBtn = false;
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    }
  }
};
</script>
<style lang="scss" scoped>
body .form-area .form-group label span {
  color: red;
}
body .white-row.loader-route {
  top: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
section {
  padding: 25px 0;
  border-bottom: 1px solid #ebebeb;
  width: 100%;
  &.top-heading-section-invoice {
    border-bottom: none;
    padding-top: 0;
    padding-bottom: 0;
    .general-filters {
      .form-actions {
        padding: 0;
        button {
          padding: 6px 25px;
          margin-left: 0;
        }
      }
    }
    .sub-heading {
      padding: 10px 0;
      margin: 0;
    }
  }
  &.invoice-itmes-section {
    padding-top: 0;
    border: none;
    .list-item-cart {
      hr {
        width: 98%;
      }
    }
    .item-add-btn {
      padding: 10px 13px 0;
    }
  }
}
.blk {
  display: block;
  width: 100%;
}
</style>
